import React from "react";
import estilo from './estilo.module.css'

const NotFound =()=>{
    return(
        <div className={estilo.estilo} >
             <h1> Opps !!! No se ha encontrado </h1>
        </div>
    )
}
export default NotFound;
